
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24","height":"24","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"id-26a","d":"M16.574 9.244a.837.837 0 011.181 0 .832.832 0 010 1.179L13 15.167l-4.755-4.744a.832.832 0 010-1.179.837.837 0 011.18 0L13 12.81l3.574-3.566z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"12","fill":"#FFB657"}}),_c('use',{attrs:{"fill":"#FFF","transform":"rotate(-90 13 12.083)","xlink:href":"#id-26a"}})])])
          )
        }
      }
    